export enum CastExaminationType {
  orderCount = "接客件数",
  shiftCount = "出勤日数",
}
